import { Translate } from '../../../shared/LanguageService';

export function isBrokerAgent(userRole: string): boolean {
    switch (userRole) {
        case 'role/broker-agent':
        case 'role/broker-agent-assistant':
        case 'role/broker-agent-admin':
            return true;
        default:
            return false;
    }
}

export function getBrokerAgentPhotoStatus(
    photoStatus: string,
    customerPhotoStatus: string
): string {
    switch (photoStatus) {
        case 'photo-order/status/uploading':
        case 'photo-order/status/uploader-approved':
        case 'photo-order/status/editoruploading':
        case 'photo-order/status/editorapproved':
        case 'photo-order/status/se360disapproved':
        case 'photo-order/status/scheduled-for-customer-approval':
            return customerPhotoStatus;
        default:
            return Translate(photoStatus);
    }
}
